<template>
  <div class="vip-page">
    <!-- ==================== 顶部Hero区域 ==================== -->
    <div class="vip-page__hero">
      <div class="vip-page__hero-bg"></div>
      <div class="vip-page__hero-overlay"></div>
      
      <div class="vip-page__hero-content">
        <h1 class="vip-page__hero-title">选择您的套餐</h1>
        <p class="vip-page__hero-subtitle">开启您的音乐之旅</p>
      </div>
    </div>

    <!-- ==================== 价格套餐区域 ==================== -->
    <div class="vip-page__pricing">
      <div class="vip-page__pricing-cards">
        <!-- 月付套餐 -->
        <div class="vip-page__price-card">
          <div class="vip-page__price-top">
            <div class="vip-page__price-period">月付</div>
          </div>
          <div class="vip-page__price-body">
            <div class="vip-page__price-amount">
              <span class="vip-page__price-dollar">¥</span>
              <span class="vip-page__price-num">15</span>
              <span class="vip-page__price-per">/ 月</span>
            </div>
            <div class="vip-page__price-billed">按月付费</div>
            <button class="vip-page__price-button" @click="openPayModal('月付', 15)">开通会员</button>
          </div>
        </div>

        <!-- 年付套餐 -->
        <div class="vip-page__price-card vip-page__price-card--featured">
          <div class="vip-page__price-ribbon">最受欢迎</div>
          <div class="vip-page__price-top">
            <div class="vip-page__price-period">1年</div>
            <div class="vip-page__price-off">节省37%</div>
          </div>
          <div class="vip-page__price-body">
            <div class="vip-page__price-amount">
              <span class="vip-page__price-dollar">¥</span>
              <span class="vip-page__price-num">118.8</span>
              <span class="vip-page__price-per">/ 月</span>
            </div>
            <div class="vip-page__price-billed">每月 ¥9.9</div>
            <button class="vip-page__price-button" @click="openPayModal('年付', 118.8)">开通会员</button>
          </div>
        </div>

        <!-- 两年套餐 -->
        <div class="vip-page__price-card">
          <div class="vip-page__price-top">
            <div class="vip-page__price-period">2年</div>
            <div class="vip-page__price-off">节省50%</div>
          </div>
          <div class="vip-page__price-body">
            <div class="vip-page__price-amount">
              <span class="vip-page__price-dollar">¥</span>
              <span class="vip-page__price-num">189.6</span>
              <span class="vip-page__price-per">/ 月</span>
            </div>
            <div class="vip-page__price-billed">每月 ¥7.9</div>
            <button class="vip-page__price-button" @click="openPayModal('两年', 189.6)">开启30天免费试用</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== 会员权益 ==================== -->
    <div class="vip-page__benefits">
      <h2 class="vip-page__benefits-title">会员专享权益</h2>
      
      <div class="vip-page__benefits-list">
        <div class="vip-page__benefit-row">
          <div class="vip-page__benefit-info">
            <div class="vip-page__benefit-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
              </svg>
            </div>
            <div class="vip-page__benefit-text">
              <h3 class="vip-page__benefit-name">收纳世间原创旋律，珍藏人间诗意歌声</h3>
              <p class="vip-page__benefit-desc">每天无限畅听所有类型、抢先聆听您喜爱类型中的新增音乐。</p>
            </div>
          </div>
          <div class="vip-page__benefit-visual">
            <div class="vip-page__benefit-img">
              <img src="../../assets/11.png" alt="音乐频道" />
            </div>
          </div>
        </div>

        <div class="vip-page__benefit-row">
          <div class="vip-page__benefit-info">
            <div class="vip-page__benefit-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
            </div>
            <div class="vip-page__benefit-text">
              <h3 class="vip-page__benefit-name">人工精选音乐</h3>
              <p class="vip-page__benefit-desc">每个音乐类型都由热爱音乐的专业人士精心打造，为您带来独一无二的聆听体验。</p>
            </div>
          </div>
          <div class="vip-page__benefit-visual">
            <div class="vip-page__benefit-img">
              <img src="../../assets/12.png" alt="人工精选" />
            </div>
          </div>
        </div>

        <div class="vip-page__benefit-row">
          <div class="vip-page__benefit-info">
            <div class="vip-page__benefit-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/>
              </svg>
            </div>
            <div class="vip-page__benefit-text">
              <h3 class="vip-page__benefit-name">只听原创，拒绝复刻</h3>
              <p class="vip-page__benefit-desc">享受音乐本该有的样子：清晰、连续、完全无广告。告别破坏心情的商业广告。</p>
            </div>
          </div>
          <div class="vip-page__benefit-visual">
            <div class="vip-page__benefit-img">
              <img src="../../assets/13.png" alt="无广告" />
            </div>
          </div>
        </div>

        <div class="vip-page__benefit-row">
          <div class="vip-page__benefit-info">
            <div class="vip-page__benefit-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
              </svg>
            </div>
            <div class="vip-page__benefit-text">
              <h3 class="vip-page__benefit-name">忠于原创，听见真我</h3>
              <p class="vip-page__benefit-desc">沉浸在水晶般清晰的320kbps MP3和优化的128kbps AAC音质中。灵活的音频选项，让您在家或出行都能享受完美体验。</p>
            </div>
          </div>
          <div class="vip-page__benefit-visual">
            <div class="vip-page__benefit-img">
              <img src="../../assets/14.png" alt="高品质音频" />
            </div>
          </div>
        </div>

        <div class="vip-page__benefit-row">
          <div class="vip-page__benefit-info">
            <div class="vip-page__benefit-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/>
              </svg>
            </div>
            <div class="vip-page__benefit-text">
              <h3 class="vip-page__benefit-name">一方原创乐土，安放所有创作热爱</h3>
              <p class="vip-page__benefit-desc">我们的功能一直在为您喜爱的类型寻找最佳歌曲。但有时候，您想要自己掌控。使用跳过功能，您可以立即跳到下一首好歌。</p>
            </div>
          </div>
          <div class="vip-page__benefit-visual">
            <div class="vip-page__benefit-img">
              <img src="../../assets/15.png" alt="跳过歌曲" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== 音乐网络 ==================== -->
    <div class="vip-page__network">
      <h2 class="vip-page__network-title">以原创为核心，搭建创作者与听众的桥梁，让小众佳作被看见，让音乐创作拥有归属之地。</h2>
      
      <div class="vip-page__network-logos">
        <div class="vip-page__network-item">静谧纯音</div>
        <div class="vip-page__network-item">松弛放松</div>
        <div class="vip-page__network-item">沉思独白</div>
        <div class="vip-page__network-item">暖心小调</div>
        <div class="vip-page__network-item">轻快律动</div>
        <div class="vip-page__network-item">催泪抒情</div>
      </div>
    </div>

    <!-- ==================== 常见问题 ==================== -->
    <div class="vip-page__faq">
      <h2 class="vip-page__faq-title">常见问题</h2>
      
      <div class="vip-page__faq-list">
        <div class="vip-page__faq-item" v-for="(faq, index) in faqList" :key="index" @click="toggleFaq(index)">
          <div class="vip-page__faq-q">
            <span>{{ faq.question }}</span>
            <svg class="vip-page__faq-icon" :class="{ 'vip-page__faq-icon--open': faq.open }" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
            </svg>
          </div>
          <div class="vip-page__faq-a" v-show="faq.open">
            {{ faq.answer }}
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== 微信支付弹窗 ==================== -->
    <div class="vip-page__pay-modal" v-if="showPayModal" @click.self="closePayModal">
      <div class="vip-page__pay-modal-content">
        <button class="vip-page__pay-modal-close" @click="closePayModal">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <div class="vip-page__pay-success-state" v-if="paySuccess">
          <div class="vip-page__pay-success-icon">
            <svg viewBox="0 0 24 24" fill="#d4a04a" width="80" height="80">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          </div>
          <div class="vip-page__pay-success-title">支付成功</div>
          <div class="vip-page__pay-success-desc">恭喜您成为Yours会员</div>
          <div class="vip-page__pay-success-info">
            <p>订单号：{{ orderNo }}</p>
            <p>支付金额：¥{{ payAmount.toFixed(2) }}</p>
          </div>
          <button class="vip-page__pay-success-btn" @click="closePayModal">完成</button>
        </div>

        <div class="vip-page__pay-paying-state" v-else>
          <div class="vip-page__pay-header">
            <div class="vip-page__pay-logo">
              <img src="../../assets/logo.png" alt="Yours Logo" class="vip-page__pay-logo-img" />
            </div>
            <!-- <div class="vip-page__pay-merchant-name">Yours</div> -->
          </div>

          <div class="vip-page__pay-amount-box">
            <span class="vip-page__pay-amount-label">支付金额</span>
            <span class="vip-page__pay-amount-value">¥{{ payAmount.toFixed(2) }}</span>
          </div>

          <div class="vip-page__pay-qr-container">
            <div class="vip-page__pay-qr-box">
              <img src="../../assets/erweima.png" alt="微信支付二维码" style="width: 50%; height:50%;background-color: #fff; padding: 10px 10px;" />
            </div>
            <div class="vip-page__pay-qr-tip">
              <svg viewBox="0 0 24 24" fill="#d4a04a" width="16" height="16">
                <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 01.598.082l1.584.926a.272.272 0 00.14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.04-.177l-.322-1.233a.582.582 0 01-.023-.156.49.49 0 01.201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-6.656-6.088V8.89c-.135-.01-.269-.03-.407-.032zm-2.53 3.274c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.969-.982z"/>
              </svg>
              请使用微信扫描二维码支付
            </div>
          </div>

          <div class="vip-page__pay-modal-footer">
            <button class="vip-page__pay-cancel" @click="closePayModal">取消支付</button>
            <button class="vip-page__pay-confirm" @click="simulatePaySuccess">确认支付</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Vip',
  data() {
    return {
      showPayModal: false,
      paySuccess: false,
      payPlan: '',
      payAmount: 0,
      orderNo: '',
      payTimer: 600,
      payTime: '',
      timerInterval: null,
      faqList: [
        {
          question: '你们接受哪些支付方式？',
          answer: '我们接受信用卡、支付宝、微信支付和其他主流支付方式。您可以选择最方便的付款方式。',
          open: false
        },
        {
          question: '我可以在多少台设备上使用？',
          answer: '开通会员账户可以在多台设备上使用，包括手机、平板、电脑和智能音箱。',
          open: false
        },
        {
          question: '我可以在车里听吗？',
          answer: '是的，您可以通过蓝牙、CarPlay、Android Auto和其他支持的车载系统在车内收听。',
          open: false
        },
        {
          question: '音质有多好？',
          answer: '开通会员享受全站音乐聆听，全站高品质音频，全是原创版本、更清晰、细节更丰富。',
          open: false
        },
        {
          question: '包含哪些类型？',
          answer: '可以点击我们网站中的频道栏目，包括治愈暖心、治愈、松弛放松、安抚疗愈、温情叙事、静谧。',
          open: false
        },
        {
          question: '支持哪些设备？',
          answer: '我们支持Android手机平板、Windows和Mac电脑，等智能设备。',
          open: false
        }
      ]
    }
  },
  methods: {
    toggleFaq(index) {
      this.faqList[index].open = !this.faqList[index].open
    },
    openPayModal(plan, amount) {
      const savedUser = localStorage.getItem('YousrDL')
      if (!savedUser) {
        alert('您还没有登录，请先登录后再进行充值')
        return
      }

      // 检查是否开启青少年模式（通过teenPassword判断）
      const teenPassword = localStorage.getItem('teenPassword')
      if (teenPassword) {
        alert('青少年模式下禁止充值')
        return
      }

      this.payPlan = plan
      this.payAmount = amount
      this.orderNo = this.generateOrderNo()
      this.payTimer = 600
      this.paySuccess = false
      const date = new Date()
      this.payTime = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`
      this.showPayModal = true
      this.startTimer()
    },
    closePayModal() {
      this.showPayModal = false
      this.stopTimer()
      this.paySuccess = false
      this.payAmount = 0
      this.orderNo = ''
      this.payTimer = 180
      this.payTime = ''
    },
    generateOrderNo() {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      const second = String(date.getSeconds()).padStart(2, '0')
      const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0')
      return `VIP${year}${month}${day}${hour}${minute}${second}${random}`
    },
    startTimer() {
      this.stopTimer()
      this.timerInterval = setInterval(() => {
        if (this.payTimer > 0) {
          this.payTimer--
        } else {
          this.closePayModal()
          alert('支付已超时，请重新支付')
        }
      }, 1000)
    },
    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    simulatePaySuccess() {
      this.stopTimer()
      this.paySuccess = true
      this.updateVipStatus()
    },
    updateVipStatus() {
      const savedUser = localStorage.getItem('YousrDL')
      if (!savedUser) return

      const userInfo = JSON.parse(savedUser)
      if (!userInfo) return

      userInfo.isnovip = 1
      localStorage.setItem('YousrDL', JSON.stringify(userInfo))
    }
  }
}
</script>

<style scoped lang="scss">
.vip-page {
  width: 100%;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #5c2a2a;
  color: #ffffff;

  &__hero {
    position: relative;
    min-height: 280px;
    padding: 50px 20px 100px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow: hidden;
  }

  &__hero-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('../../assets/vip_bj.jpg');
    background-size: cover;
    background-position: center center;
  }

  &__hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgb(92 42 42 / 26%) 0%, rgb(92 42 42) 100%);
  }

  &__hero-content {
    position: relative;
    z-index: 2;
  }

  &__hero-title {
    font-size: 28px;
    font-weight: 400;
    color: #f5e6d0;
    margin: 0 0 8px 0;
    line-height: 1.3;
    font-family: Georgia, 'Times New Roman', serif;
    font-style: italic;
  }

  &__hero-subtitle {
    font-size: 16px;
    color: rgba(245, 230, 208, 0.7);
    margin: 0;
  }

  &__pricing {
    margin-top: -80px;
    position: relative;
    z-index: 10;
    padding: 0 20px;
  }

  &__pricing-cards {
    display: flex;
    max-width: 960px;
    margin: 0 auto;
    align-items: stretch;
    justify-content: center;
  }

  &__price-card {
    flex: 1;
    background-color: #f5e6d0;
    color: #333333;
    border-radius: 6px 0 0 6px;
    overflow: hidden;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
    position: relative;

    &:nth-child(3) {
      border-radius: 0 6px 6px 0;
    }

    &--featured {
      flex: 1.05;
      z-index: 5;
      border-radius: 6px;
      transform: scale(1.03);
    }
  }

  &__price-ribbon {
    position: absolute;
    top: -1px;
    left: 0;
    right: 0;
    background: linear-gradient(to bottom, #c44e4e, #a33a3a);
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    padding: 10px 0;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 1px;
    z-index: 10;
    border-radius: 6px 6px 0 0;
  }

  &__price-top {
    padding: 28px 25px 18px;
    text-align: center;
    background-color: #efe0c8;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    .vip-page__price-card--featured & {
      padding-top: 50px;
    }
  }

  &__price-period {
    font-size: 20px;
    font-weight: 700;
    color: #222222;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  &__price-off {
    background: linear-gradient(to right, #e63946, #d62828);
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 3px;
    text-transform: uppercase;
  }

  &__price-body {
    padding: 30px 25px 35px;
    text-align: center;
  }

  &__price-amount {
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin-bottom: 15px;
  }

  &__price-dollar {
    font-size: 28px;
    font-weight: 400;
    color: #d4a04a;
    margin-right: 2px;
  }

  &__price-num {
    font-size: 64px;
    font-weight: 700;
    color: #d4a04a;
    line-height: 1;
    font-family: Georgia, 'Times New Roman', serif;
  }

  &__price-per {
    font-size: 16px;
    color: #666666;
    margin-left: 4px;
  }

  &__price-billed {
    font-size: 14px;
    color: #666666;
    margin-bottom: 25px;
  }

  &__price-button {
    width: 100%;
    padding: 14px 20px;
    background: linear-gradient(to bottom, #e8b04a, #d4953a);
    color: #ffffff;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);

    &:hover {
      background: linear-gradient(to bottom, #d4953a, #c08030);
    }
  }

  &__benefits {
    padding: 60px 20px;
    max-width: 960px;
    margin: 0 auto;
  }

  &__benefits-title {
    font-size: 26px;
    font-weight: 400;
    color: #f5e6d0;
    text-align: center;
    margin: 0 0 30px 0;
    font-family: Georgia, 'Times New Roman', serif;
    font-style: italic;
    position: relative;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      width: 100px;
      height: 1px;
      background-color: rgba(245, 230, 208, 0.2);
    }

    &::before {
      left: calc(50% - 160px);
    }

    &::after {
      right: calc(50% - 160px);
    }
  }

  &__benefits-list {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  &__benefit-row {
    display: flex;
    align-items: center;
    padding: 40px 0;
    border-bottom: 1px solid rgba(245, 230, 208, 0.15);
    gap: 50px;

    &:last-child {
      border-bottom: none;
    }
  }

  &__benefit-info {
    flex: 1;
    display: flex;
    align-items: flex-start;
    gap: 20px;
  }

  &__benefit-icon {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    color: #f5e6d0;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__benefit-text {
    flex: 1;
  }

  &__benefit-name {
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 12px 0;
  }

  &__benefit-desc {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.75);
    margin: 0;
    line-height: 1.6;
  }

  &__benefit-visual {
    flex-shrink: 0;
    width: 300px;
  }

  &__benefit-img {
    border-radius: 8px;
    overflow: hidden;
    opacity: 0.9;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  &__network {
    padding: 50px 20px;
    border-top: 1px solid rgba(245, 230, 208, 0.15);
    border-bottom: 1px solid rgba(245, 230, 208, 0.15);
  }

  &__network-title {
    font-size: 24px;
    font-weight: 400;
    color: #f5e6d0;
    text-align: center;
    margin: 0 0 35px 0;
    font-family: Georgia, 'Times New Roman', serif;
    font-style: italic;
  }

  &__network-logos {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
    max-width: 800px;
    margin: 0 auto;
  }

  &__network-item {
    padding: 15px 25px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    font-size: 15px;
    font-weight: 900;
    color: rgba(245, 230, 208, 0.8);
    font-family: Georgia, 'Times New Roman', serif;
    font-style: italic;
  }

  &__faq {
    padding: 50px 20px;
    max-width: 750px;
    margin: 0 auto;
  }

  &__faq-title {
    font-size: 24px;
    font-weight: 400;
    color: #f5e6d0;
    text-align: center;
    margin: 0 0 30px 0;
    font-family: Georgia, 'Times New Roman', serif;
    font-style: italic;
  }

  &__faq-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__faq-item {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.25);
    }
  }

  &__faq-q {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 22px;
    font-size: 15px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
  }

  &__faq-icon {
    width: 20px;
    height: 20px;
    color: rgba(255, 255, 255, 0.5);
    transition: transform 0.3s ease;
    flex-shrink: 0;

    &--open {
      transform: rotate(180deg);
    }
  }

  &__faq-a {
    padding: 0 22px 18px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.65);
    line-height: 1.7;
  }

  &__footer {
    margin-top: 40px;
    background-color: rgba(0, 0, 0, 0.25);
  }

  &__footer-brand {
    padding: 30px 20px;
    border-bottom: 1px solid rgba(245, 230, 208, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;
  }

  &__footer-brand-name {
    font-size: 14px;
    font-weight: 900;
    color: rgba(245, 230, 208, 0.5);
    font-family: Georgia, 'Times New Roman', serif;
    font-style: italic;
  }

  &__footer-bottom {
    padding: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  &__footer-social {
    display: flex;
    gap: 20px;
  }

  &__footer-social-link {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(245, 230, 208, 0.4);
    transition: color 0.2s;

    &:hover {
      color: #f5e6d0;
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }

  &__footer-copy {
    font-size: 12px;
    color: rgba(245, 230, 208, 0.3);
  }
  &__pay-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(154, 31, 19, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
  }

  &__pay-modal-content {
    width: 100%;
    max-width: 380px;
    aspect-ratio: 1;
    background: linear-gradient(to bottom, #b02518 0%, #8a1a12 100%);
    border-radius: 8px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    padding: 30px;
    box-sizing: border-box;
    animation: payModalIn 0.3s ease;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__pay-modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: none;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.7);
    transition: all 0.2s;
    border-radius: 4px;

    &:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.1);
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }

  &__pay-success-state {
    text-align: center;
    animation: successIn 0.4s ease;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  &__pay-success-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
    animation: successBounce 0.6s ease;
  }

  &__pay-success-title {
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 8px;
  }

  &__pay-success-desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 20px;
  }

  &__pay-success-info {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;
    text-align: left;
    width: 100%;

    p {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      margin: 6px 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__pay-success-btn {
    width: 100%;
    padding: 14px;
    background-color: #d4a04a;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #c08030;
    }
  }

  &__pay-paying-state {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
  }

  &__pay-header {
    text-align: center;
    margin-bottom: 20px;
  }

  &__pay-logo {
    margin-bottom: 8px;
  }

  &__pay-logo-img {
    width: 160px;
    object-fit: contain;
    border-radius: 8px;
  }

  &__pay-merchant-name {
    font-size: 18px;
    font-weight: 600;
    color: #f5e6d0;
    font-family: Georgia, 'Times New Roman', serif;
  }

  &__pay-amount-box {
    text-align: center;
    margin-bottom: 20px;
  }

  &__pay-amount-label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    display: block;
    margin-bottom: 8px;
  }

  &__pay-amount-value {
    font-size: 36px;
    font-weight: 700;
    color: #f5e6d0;
    font-family: Georgia, 'Times New Roman', serif;
  }

  &__pay-qr-container {
    text-align: center;
    margin-bottom: 16px;
  }

  &__pay-qr-box {
    display: inline-block;
    padding: 12px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &__pay-qr-svg {
    display: block;
    border-radius: 6px;
  }

  &__pay-qr-tip {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 12px;
  }

  &__pay-modal-footer {
    display: flex;
    width: 100%;
    gap: 10px;
  }

  &__pay-cancel {
    flex: 1;
    padding: 12px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    background: none;
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border-radius: 6px;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: #ffffff;
    }
  }

  &__pay-confirm {
    flex: 1;
    padding: 12px;
    border: none;
    background: linear-gradient(to bottom, #e8b04a, #d4953a);
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    border-radius: 6px;

    &:hover {
      background: linear-gradient(to bottom, #d4953a, #c08030);
    }
  }
}

@keyframes payModalIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes successIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes successBounce {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .vip-page {
    &__pricing-cards {
      flex-direction: column;
      gap: 20px;
    }

    &__price-card {
      border-radius: 6px;

      &:nth-child(3) {
        border-radius: 6px;
      }

      &--featured {
        transform: none;
      }
    }

    &__benefit-row {
      flex-direction: column-reverse;
      gap: 25px;
    }

    &__benefit-visual {
      width: 100%;
    }

    &__benefits-title {
      &::before,
      &::after {
        width: 50px;
      }

      &::before {
        left: calc(50% - 110px);
      }

      &::after {
        right: calc(50% - 110px);
      }
    }

    &__footer-brand {
      gap: 15px;
    }
  }
}
</style>
